require('waypoints/lib/jquery.waypoints.min');

$('a[rel="external"]').attr('target', '_blank');

$('.animate-on-scroll').each(function() {
  $(this).addClass('pending-animation');
});


$('.animate-on-scroll').waypoint({
  handler: function(direction) {
    $(this.element).addClass("animate-initiate");
  },
  offset: '97%'
});

$(document).ready(function() {

  $('.nav-toggle').on('click', function() {
    if ($('#header').hasClass('js-open')) {
      $('#header').removeClass('js-open');
      $('#main-navigation').removeClass('js-shown');
    } else {
      $('#header').addClass('js-open');
      $('#main-navigation').addClass('js-shown');
    }
  });

  var $logoheight = $(".site-logo").outerHeight()
  $(window).scroll(function () {
    var $scroll = $(window).scrollTop();
    if ($scroll >= $logoheight) {
      $(".site-logo").addClass("js-logo--small");
      $(".nav-secondary__wrapper").addClass("js-nav-secondary__wrapper--small");
      $(".nav-primary__wrapper").addClass("js-nav-primary__wrapper--small");
    } else {
      $(".site-logo").removeClass("js-logo--small");
      $(".nav-secondary__wrapper").removeClass("js-nav-secondary__wrapper--small");
      $(".nav-primary__wrapper").removeClass("js-nav-primary__wrapper--small");
    }
  });

  $('.nav-primary a').on('focus', function () {
    $(this).parents('li').addClass('focussed');
  }).on('blur', function () {
    $(this).parents('li').removeClass('focussed');
  });

});


(function() {

  var youtube = document.querySelectorAll(".youtube");

  for (var i = 0; i < youtube.length; i++) {

    var source = "https://img.youtube.com/vi/" + youtube[i].dataset.embed + "/sddefault.jpg";

    var image = new Image();
    image.src = source;
    image.addEventListener("load", function () {
      youtube[i].appendChild(image);
    }(i));

    youtube[i].addEventListener("click", function () {

      var iframe = document.createElement("iframe");

      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("allowfullscreen", "");
      iframe.setAttribute("src", "https://www.youtube.com/embed/" + this.dataset.embed + "?rel=0&showinfo=0&autoplay=1");

      this.innerHTML = "";
      this.appendChild(iframe);
    });
  };

})();



if (typeof $(".isotope-grid").isotope == 'function') {
    var $grid = $('.isotope-grid').isotope({
      // main isotope options
      itemSelector: '.isotope-grid-item',
      // set layoutMode
      layoutMode: 'masonry'
    })
    jQuery(window).on('load', function () {
      var $ = jQuery;
      var $grid = $('.isotope-grid').isotope({
        // main isotope options
        itemSelector: '.isotope-grid-item',
        // set layoutMode
        layoutMode: 'masonry'
      })
    });
    $filters = $('.isotope-filters').on('click', 'button', function () {
      var $this = $(this);
      var filterFns = {
      };
      var filterValue = $(this).attr('data-filter');
      if ($this.is('.is-checked')) {
        // uncheck
        filterValue = '*';
      } else {
        filterValue = $this.attr('data-filter');
        $filters.find('.is-checked').removeClass('is-checked');
      }
      $this.toggleClass('is-checked');

      filterValue = filterFns[filterValue] || filterValue;
      $grid.isotope({ filter: filterValue });
    });
}

(function ($) {

  $('li').hover(
    function () { $(this).addClass("wpacc-hover"); },
    function () { $(this).delay('250').removeClass("wpacc-hover"); }
  );

  $('a').on('focus blur',
    function () { $(this).parents("li").toggleClass("wpacc-hover"); }
  );

}

  (jQuery)

);


$('.shutter-title').on('click',
  function () { $(this).toggleClass('active'); }
);
